// src/services/ScreenService.js
//
// Paired wall screens. See displayKey.js for why a screen holds a key rather
// than signing in as a user.

import apiClient from './apiClient'

/** Admin: mint a one-time code for a screen about to be paired. */
export async function createPairingCode(name, allowedIp = '') {
  const response = await apiClient.post('/CreatePairingCode', {
    name,
    allowed_ip: allowedIp
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not create a code')
  }

  return {
    code: response.data.code,
    expiresInSeconds: response.data.expires_in_seconds ?? 600
  }
}

/**
 * The screen: exchange a code for a key.
 *
 * Unauthenticated, because the screen has nothing yet. The code is the
 * credential, once. Goes through apiClient so it takes the same path as
 * everything else; with no key stored yet and no MSAL account, the request
 * interceptor attaches nothing, which is correct.
 */
export async function pairScreen(code) {
  const response = await apiClient.post('/PairScreen', { code })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'That code is not valid')
  }

  return {
    key: response.data.key,
    name: response.data.name
  }
}

export async function listScreens() {
  const response = await apiClient.post('/ListScreens', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read screens')
  }
  return response.data.screens ?? []
}

export async function revokeScreen(id) {
  const response = await apiClient.post('/RevokeScreen', { id })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not revoke the screen')
  }
}
